import React from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

interface LevelCardProps {
  title: string;
  progress: number;
  description: string;
  lessons: number;
  totalTime: string;
  color?: string;
}

const LevelCard: React.FC<LevelCardProps> = ({
  title,
  progress,
  description,
  lessons,
  totalTime,
  color = "#00bfa6",
}) => {
  return (
    <Card className="p-3 level-card h-100" style={{ borderRadius: "10px" }}>
      <div className="level-card-body">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0 fw-bold">{title}</h6>
          <div style={{ width: 50, height: 50 }}>
            <CircularProgressbar
              value={progress}
              text={`${progress}%`}
              strokeWidth={8}
              styles={buildStyles({
                textSize: "28px",
                pathColor: color,
                textColor: "#000",
                trailColor: "#f4f7fa",
              })}
            />
          </div>
        </div>

        {/* Description with Tooltip */}
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip className="level-tooltip">
              <div
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </Tooltip>
          }
        >
          <div className="level-card-description text-muted">
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </OverlayTrigger>

        <hr />

        {/* Footer */}
        <div className="level-card-footer">
          <Row>
            <Col>
              <div className="fw-bold">{lessons}</div>
              <small className="text-muted">Lessons</small>
            </Col>
            <Col>
              <div className="fw-bold">{totalTime}</div>
              <small className="text-muted">Total time</small>
            </Col>
          </Row>
        </div>
      </div>
    </Card>
  );
};

export default LevelCard;
